import { print } from 'graphql'
import { Product } from 'shopify-types'

import { cachedStorefrontClient } from '..'
import { GetProductsByIdsDocument, type GetProductsByIdsQuery } from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { type GQLProduct, mapGQLProductToProduct } from './graphql'

const isProduct = (node: GetProductsByIdsQuery['nodes'][number]): node is GQLProduct =>
  Boolean(node && 'variants' in node)

export const fetchMultipleProducts =
  (options: GlobalRequestOptions) =>
  async (ids: string[]): Promise<Product[]> => {
    if (ids.length === 0) {
      return []
    }

    const response = await cachedStorefrontClient.request<GetProductsByIdsQuery>(
      print(GetProductsByIdsDocument),
      {
        variables: {
          ids,
          language: options.language,
          country: options.language.toUpperCase() === 'PL' ? 'PL' : 'DE',
        },
      },
    )

    const products = response.data?.nodes.filter(isProduct)

    if (!products || products.length === 0) {
      throw new Error('Products not found')
    }

    return products.map(mapGQLProductToProduct)
  }
